var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-container"},[_c('div',{ref:"editor",staticClass:"editor-container",attrs:{"contenteditable":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }